export const handleAvatarString = (name, surname) => {
    return name && surname && `${name} ${surname[0]}.`;
};
